import { AmplifilesClient } from "./api-client";
import { ReferralOverviewDto } from "@repo/api/referral";

export class ReferralApi {
  static async getReferralOverview(teamExternalId: string) {
    const response = await AmplifilesClient.instance.get(
      `/team/${teamExternalId}/referral-overview`,
    );

    return ReferralOverviewDto.parse(response.data);
  }
}
